<template>
  <div class="ui grid px-gen m-0 charts-nvidia py-1">
    <div class="eight wide column pl-0 pt-0 pb-05">
      <div class="is-uppercase">Grafica semanal de envios</div>
      <img
        class="ui fluid image"
        src="https://thewhitelot.us/nvidia-code/img/chart1.png"
      />
    </div>
    <div class="eight wide column pl-0 pt-0 pb-05">
      <div class="is-uppercase">total de envios por plataforma</div>
      <img
        class="ui fluid image"
        src="https://thewhitelot.us/nvidia-code/img/chart2.png"
      />
    </div>
    <div class="eight wide column pl-0 pt-0 pb-05">
      <div class="is-uppercase">Total por gpu de orden ascencedentes</div>
      <img
        class="ui fluid image"
        src="https://thewhitelot.us/nvidia-code/img/chart3.png"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "NvidiaTicketNvidiaReportesStore",
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
  watch: {},
};
</script>

<style scoped>
/* @import url("https://nworkforce.com/librerias/css/fonts/fonts.css"); */

/*  SPACING   */
.py-05 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.m-0 {
  margin: 0 !important;
}
.my-0 {
  margin-bottom: 0 !important;
  margin-top: 0 !important;
}
.px-gen {
  padding-right: 2rem !important;
  padding-left: 2rem !important;
}
.pl-0 {
  padding-left: 0 !important;
}

/*  FONTS   */
.has-text-centered {
  text-align: center !important;
}
.has-text-left {
  text-align: left !important;
}
.is-uppercase {
  text-transform: uppercase !important;
}
.fdinpro {
  font-family: "DINPro" !important;
}

/*  GRAFICAS    */
.charts-nvidia div .is-uppercase {
  background-color: #666666 !important;
  color: white !important;
  padding: 0.5rem 1rem 0.5rem;
}
</style>
